<template>
  <div id="slider_section" :class="hideTitles.includes(mainInfo.main.cardType) ? 'pt-8' : ''">
<!--    <div v-if="circleBackground.includes(mainInfo.main.cardType)" class="circle-background"></div>-->
    <div v-if="!hideTitles.includes(mainInfo.main.cardType)" class="main-title">{{mainInfo.main.title}}</div>
    <div :class="[lang === 'ar' ? 'flex-row-reverse right-dir' : '' , 'slider-description d-flex mx-auto']">
      <div :class="routing === 'popular-bundles' || routing === 'all-offers' ? 'pointer' : 'default'">
        <router-link :to="routing === 'popular-bundles' ? '/bundles' : routing === 'all-offers' ? '/offers' : ''">
          <a>
            <span v-if="!hideTitles.includes(mainInfo.main.cardType)" class="description" :class="routing === 'popular-bundles' || routing === 'all-offers' ? ' underline-1' : ''">
            {{mainInfo.main.description}}
            </span>
            <span v-if="!hideArrows.includes(mainInfo.main.cardType) && routing === 'popular-bundles' || routing === 'all-offers'">
             <img :class="[lang === 'ar' ? 'mr-2' : '' ,'arrows']" src="../../assets/icons/arrows.svg">
            </span>
          </a>
        </router-link>
      </div>
    </div>
    <slider-layout :lineType="lineType" :obj="obj" :method="method" :sliderHolder="sliderHolder" :extraUrl="extraUrl" :pressType="cardType" :id="id" :data="mainInfo" v-if="refresh" @total-elements="calcTotal" @refreshSlider="refreshSliderHandler" />
    <div v-if="totalElements > pageSize || data.sliderType === 'cardsMiniSlider'" class="swipe">
      <div v-observe-visibility="visibilityChanged"></div>
      <img class="icon" src="../../assets/icons/swipe.svg">
      <div class="swipe-icon">{{$t('swipe')}}</div>
    </div>
  </div>
</template>

<script>
import SliderLayout from '../sliders/SliderLayout'
import $ from 'jquery'
export default {
  name: 'SliderSection',
  components: { SliderLayout },
  props: {
    data: {
      type: Object
    },
    totalPages: Number,
    show: Boolean,
    error: Boolean,
    id: String,
    routing: String,
    sectionType: String,
    cardType: String,
    /* -------------- new methodology ------------- */
    method: String,
    obj: Object,
    sliderHolder: String,
    extraUrl: String,
    lineType: Number
  },
  watch: {
    show (val) {
      this.show = val
    }
  },
  data () {
    return {
      route: '',
      refresh: true,
      hideTitles: ['social-responsibility', 'press-releases'],
      hideArrows: ['social-responsibility', 'press-releases', 'investor-relations'],
      clickableDesc: ['bundle', 'offer'],
      // circleBackground: ['investor_relations'],
      // backgrounds: ['press-releases', 'offer'],
      mainInfo: {
        main: { cardType: 'basic', title: '', description: '', image: '' },
        slider: []
      },
      lang: this.$lang,
      pageSize: 0,
      totalElements: 0
    }
  },
  created () {
    this.mainInfo = this.data
  },
  mounted () {
    setTimeout(() => {
      // $('#investor_relations #slider_section').css('padding-bottom', '40px')
      this.$lang === 'ar' ? $('.main-title').css('font-family', 'Mtn-arabic-bold') : $('.main-title').css('font-family', 'Mtn-bold-italic')
      this.$lang === 'ar' ? $('.swipe').css('font-family', 'Mtn-arabic-bold') : $('.swipe').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('#slider_section .description').css('font-family', 'Mtn-arabic-regular') : $('#slider_section .description').css('font-family', 'Mtn-regular')
    })
  },
  methods: {
    calcTotal (val) {
      this.totalElements = val.total
      this.pageSize = val.pageSize
      // console.log(this.totalElements, this.pageSize)
    },
    visibilityChanged (isVisible) {
      $('.icon').addClass('swiping')
      setTimeout(() => {
        $('.icon').removeClass('swiping')
      }, 2000)
    },
    refreshSliderHandler () {
      // Removing my-component from the DOM
      this.refresh = false
      this.$nextTick(() => {
        // Adding the component back in
        this.refresh = true
      })
    },
    getPageSize (val) {
      this.pageSize = val
      // console.log(val)
      this.$emit('page-size', val)
    },
    changeForward (val) {
      this.$emit('change-forward', val)
    },
    changeBackward (val) {
      this.$emit('change-backward', val)
    },
    handleRoute () {
      // this.route = this.routing === 'popular-bundles' ? '/bundles' : this.routing === 'all-offers' ? 'offers' : ''
      if (this.routing === 'popular-bundles') {
        this.route = '/bundles'
      } else if (this.routing === 'all-offers') {
        this.route = '/offers'
      }
    }
  }
}
</script>

<style scoped>
.pointer{
  cursor: pointer;
}
.default a {
  cursor: default !important;
}
#slider_section {
  /*padding: calc(calc(100vh - 1305px) / 2) 0;*/
  position: relative;
  background-size: cover !important;
}
.slider-description{
  /*width: max-content;*/
  width: 100vw;
  justify-content: center;
  align-items: center;
  padding: 0 5vw;
}
.main-title {
  /*font-family: Mtn-bold-italic !important;*/
}
/*.circle-background{*/
/*  background-image: url("../../assets/images/MtnAppBack.png");*/
/*  position: absolute;*/
/*  width: 100% !important;*/
/*  height: 100%;*/
/*  z-index: 0;*/
/*  right: 0;*/
/*  transform: rotate(180deg);*/
/*  background-position: right;*/
/*}*/
.swiping{
  animation-name: translate;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
  animation-iteration-count: 4;
  animation-direction: alternate;
}
@keyframes translate {
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(90deg)
  }
}
</style>
